import { Provider, useDispatch, useSelector } from 'react-redux';
import configureStore from './store/configureStore';
import { Routes, Route, BrowserRouter, useNavigate, useSearchParams } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import ModalProvider from './provider/ModalProvider';
import TableProvider from './provider/TableProvider';
import { Box } from '@mui/material';
import theme from './theme';
import { CLEAR_USER, SET_USER } from './store/model/user';

import { BASE_URL } from './utils/constants';

import { Suspense, lazy, useEffect, useState } from 'react';
import Loading from './components/loading/Loading';
import LayoutAuth from './components/layout/LayoutAuth';

import socket from './Socket';
import channel from './Broadcast';
import { retryLazy } from './utils/tools';
import ModalPc from './components/modal/ModalPc';

interface UserResponse extends UserDefault {
  alimtalkuse: BufferResponse;
  smsok: BufferResponse;
}

const LayoutLogin = retryLazy(() => import('./components/layout/LayoutLogin'));
const LayoutDefault = retryLazy(() => import('./components/layout/LayoutDefault'));

// store 설정파일 로드
const store = configureStore();

function App() {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const [auth, setAuth] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [attendanceMode, setAttendanceMode] = useState(false);

  useEffect(() => {
    try {
      window.Kakao.init('ddbcf21bee6865da2c724b33f4bfd6f8');
    } catch (err) {
      console.log(err);
    }

    const cur_mode = sessionStorage.getItem('mode');
    if (cur_mode && cur_mode == 'attendance') {
      setAttendanceMode(true);
    } else {
      const mode = searchParams.get('mode');
      if (mode && mode == 'attendance') {
        sessionStorage.setItem('mode', 'attendance');
        setAttendanceMode(true);
      }
    }

    async function channelListener(event: MessageEvent) {
      const data = event.data;
      if (data.type == 'login') {
        // 이미 로그인 상태면 덮어씌우기
        if (window.sessionStorage.getItem('user')) {
          if (data.payload) {
            store.dispatch({
              type: SET_USER,
              payload: data.payload,
            });
            setTimeout(() => {
              window.sessionStorage.setItem('user', JSON.stringify(data.payload));
              navigate(`${BASE_URL}/`);
            }, 0);
          }
        }
      } else if (data.type == 'logout') {
        if (window.sessionStorage.getItem('user')) {
          const user = JSON.parse(window.sessionStorage.getItem('user') as string);
          await socket.emit('logout', user);
        }

        store.dispatch({
          type: CLEAR_USER,
        });
        setTimeout(() => {
          window.sessionStorage.removeItem('user');

          navigate(`${BASE_URL}/login`, {
            state: {
              from_main: true,
            },
          });
        }, 0);
      }
    }

    if (channel) {
      channel.addEventListener('message', channelListener);
    }

    return () => {
      if (channel) {
        channel.removeEventListener('message', channelListener);
      }
    };
  }, []);

  return (
    <Box sx={{ overflowX: 'auto' }} id='root_wrapper'>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ModalProvider>
            <TableProvider>
              <Suspense fallback={<Loading isLogo={true} />}>
                {auth ? (
                  attendanceMode ? (
                    <>
                      <ModalPc visible={true} onClose={() => false} />
                    </>
                  ) : (
                    <Routes>
                      <Route path={`${BASE_URL}/*`} element={<LayoutDefault />} />
                      <Route path={`${BASE_URL}/login`} element={<LayoutLogin />} />
                    </Routes>
                  )
                ) : (
                  <Routes>
                    <Route path={`${BASE_URL}/*`} element={<LayoutAuth onSubmit={() => setAuth(true)} />} />
                  </Routes>
                )}
              </Suspense>
            </TableProvider>
          </ModalProvider>
        </Provider>
      </ThemeProvider>
    </Box>
  );
}

export default App;
